import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useRequestMagicLink, useSession } from '../auth/useSession.js';

const linkErrors: Record<string, string> = {
  invalid_link: 'That sign-in link was not valid. Please request a new one.',
  expired_link: 'That sign-in link has expired or was already used. Please request a new one.',
  not_eligible: 'That address is no longer on your employer’s list. Please contact your HR contact.',
};

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const session = useSession();
  const requestLink = useRequestMagicLink();
  const [email, setEmail] = useState('');

  const redirectTo = searchParams.get('redirectTo') ?? undefined;
  const linkError = searchParams.get('error');

  if (session.data) {
    const landing = session.data.capabilities.manageVendors
      ? '/admin'
      : session.data.capabilities.viewDashboardVendorIds !== 'all' &&
          session.data.capabilities.viewDashboardVendorIds.length > 0
        ? '/dashboard'
        : null;
    if (landing) return <Navigate to={redirectTo ?? landing} replace />;
  }

  return (
    <main>
      <h1>Voice to Value</h1>

      {linkError && linkErrors[linkError] && <p role="alert">{linkErrors[linkError]}</p>}

      {requestLink.isSuccess ? (
        <>
          <h2>Check your email</h2>
          <p>
            If <strong>{email}</strong> is on your employer’s list, a link to your survey is on its
            way. It works once and expires in 15 minutes.
          </p>
        </>
      ) : (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            requestLink.mutate({ email, redirectTo });
          }}
        >
          <p>Enter your work email address and we will send you a link to your survey.</p>
          <label htmlFor="email">Work email</label>
          <input
            id="email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <button type="submit" disabled={requestLink.isPending}>
            {requestLink.isPending ? 'Sending…' : 'Email me a survey link'}
          </button>
          {requestLink.isError && <p role="alert">{requestLink.error.message}</p>}
        </form>
      )}
    </main>
  );
}
